export default "__VITE_ASSET__lz94hLP5__"